import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import autenticacion from "./autenticacion";
import usuario from "./usuario";
import proyectos from "./proyectos";
import categorias from "./categorias";
import blog from "./blog";
import informar from "./informar";
import notificaciones from "./notificaciones";
import { auth } from "../firebase";
const estados = createPersistedState({
  paths: [
    "usuario",
    "proyectos",
    "categorias",
    "autenticacion",
    "blog",
    "notificaciones",
  ],
});

export default createStore({
  modules: {
    autenticacion,
    usuario,
    proyectos,
    categorias,
    blog,
    informar,
    notificaciones,
  },
  state: {},
  mutations: {},
  actions: {
    checkAuth({ dispatch }) {
      auth.onAuthStateChanged((user) => {
        if (user) {
          dispatch("autenticacion/setUser", user, { root: true });
        } else {
          dispatch("autenticacion/setUser", null, { root: true });
        }
      });
    },
  },
  plugins: [estados],
});
